<template>
  <div>
    <v-btn @click="isShowingInviteUserDialog = true" small :class="{'secondary': !isButtonOutlined }"  :outlined="isButtonOutlined">
      <v-icon small class="mr-2">mdi-account-plus</v-icon>
      {{ $t('z19') }}
    </v-btn>
    
    <v-dialog v-model="isShowingInviteUserDialog" :width="isInvitationForMultipleUsers ? '80%': '50%'" :persistent="isInvitationBeingSent || isInviteMultipleUsersToJoinTeamPending">
      <v-card class="px-6 pb-6 pt-6">
        <div v-if="invitingUserErrorMsg">
          <v-layout wrap>
            <v-flex xs12 text-center>
              {{ invitingUserErrorMsg }}
            </v-flex>
          </v-layout>
        </div>
        <div v-else-if="wasUserSuccessfullyInvited">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <h4 class="secondary--text">
                <v-icon class="secondary--text mr-1">mdi-check</v-icon>
                <div>{{ $t('userWasSuccessfullyInvitedMsg') }}</div>
              </h4>
            </v-flex>
          </v-layout>
        </div>
        <div v-else-if="!isInvitationBeingSent && !isInviteMultipleUsersToJoinTeamPending">
          <v-layout wrap>
            <v-flex xs12 text-end>
              <v-btn v-if="!isInvitationForMultipleUsers" small class="primary" @click="isInvitationForMultipleUsers = true">{{ $t('multiple1') }}</v-btn>
              <v-btn v-else small class="primary" @click="isInvitationForMultipleUsers = false">{{ $t('multiple2') }}</v-btn>
            </v-flex>
            <v-flex xs12 text-center>
              <img :src="images.sendEmail" height="170px" />
            </v-flex>
          </v-layout>

          <v-layout wrap justify-center v-if="isInvitationForMultipleUsers">
            <v-flex xs12 text-center>
              <h3>{{ $t('z20multiple') }}</h3>
            </v-flex>
            <v-flex xs12 sm10 mt-4>
              <small>
                <ul>
                  <li>{{ $t('z21multiple') }}</li>
                  <li>{{ $t('z22multiple') }}</li>
                  <li>{{ $t('z23multiple') }} {{ user.company.emailDomains.map(x => `@${x}`).join($t('orWord')) }}</li>
                </ul>
              </small>
            </v-flex>
            <v-flex xs12 sm10 text-center mt-3>
              <div v-if="multipleInvitesStepNb === 0">
                <v-textarea v-model="multipleInvitesTextAreaModel" :label="$t('multiple3')" outlined/>
                <v-btn class="primary" @click="goToMultipleInvitesStepNb1">{{ $t('multiple4') }}</v-btn>
              </div>
              <div v-if="multipleInvitesStepNb === 1">
                <v-layout wrap>
                  <v-flex xs12 text-left>
                    <v-btn x-small class="primary mt-2" @click="multipleInvitesStepNb = 0">
                      <v-icon x-small>mdi-arrow-left</v-icon>
                      <span>{{ $t('multiple5') }}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs9>
                    <v-layout wrap>
                      <v-flex xs12 class="mt-6 pl-3">
                        <v-form @submit.prevent="addAdditionalEmailAddress">
                          <div class="d-flex">
                            <v-text-field v-model="additionalEmailAddress" type="email" dense outlined :label="$t('multiple6')" hide-details />
                            <v-btn class="ml-6 mr-6 primary mt-1" small type="submit" @click="addAdditionalEmailAddress">{{ $t('multiple7') }}</v-btn>
                          </div>
                          <div v-if="additionalEmailAddress && !isEmailAddressOfUserToInviteOk(additionalEmailAddress)" class="text-left red--text">
                            <small>{{ $t('z23') }} {{ user.company.emailDomains.map(x => `@${x}`).join($t('orWord')) }}</small>
                          </div>
                        </v-form>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-space-around mt-3>
                      <v-flex v-for="(email, key) in multipleEmailAddresses" :key="key">
                        <v-chip class="mt-2" close @click:close="removeEmailFromMultipleEmailAddresses(email)">
                          {{ email }}
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs3 text-end>
                    <small>
                      <span>{{ multipleEmailAddresses.length }}&nbsp;</span>
                      <span v-if="multipleEmailAddresses.length > 1">{{ $t('multiple8') }}</span>
                      <span v-else>{{ $t('multiple9') }}</span>
                    </small>
                    <div>
                      <v-btn class="secondary" @click="inviteMultipleUsersToJoinTeam" :disabled="multipleEmailAddresses.length < 1">{{ $t('multiple10') }}</v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </div>

            </v-flex>
          </v-layout>

          <v-layout wrap justify-center v-else>
            <v-flex xs12 text-center>
              <h3>{{ $t('z20') }}</h3>
            </v-flex>
            <v-flex xs12 sm10 mt-4>
              <small>
                <ul>
                  <li>{{ $t('z21') }}</li>
                  <li>{{ $t('z22') }}</li>
                </ul>
              </small>
            </v-flex>
            <v-flex xs12 sm10 text-center :class="{ 'mt-5': user.data.role !== 'admin' }">
              <v-text-field v-model="emailAddressOfUserToInvite" type="email" dense outlined :label="$t('z24')" hide-details class="mt-6" />
              <div v-if="emailAddressOfUserToInvite && !isEmailAddressOfUserToInviteOk(emailAddressOfUserToInvite)" class="text-left red--text">
                <small>{{ $t('z23') }} {{ user.company.emailDomains.map(x => `@${x}`).join($t('orWord')) }}</small>
              </div>
              <v-checkbox dense color="primary switch-center" v-model="willInvitedUserBeAdmin" v-if="user.data.role === 'admin'" class="mt-2">
                <template v-slot:label>
                  <small class="primary--text">{{ $t('za') }}</small>
                </template>
              </v-checkbox>
              <v-btn @click="inviteUser" class="primary mt-4" :disabled="!isEmailAddressOfUserToInviteOk(emailAddressOfUserToInvite)">{{ $t('z25') }}</v-btn>
            </v-flex>
          </v-layout>
          


        </div>
        <div v-else>
          <v-layout wrap>
            <v-flex xs12 text-center>
              <div class="mb-2">
                <b v-if="isInvitationForMultipleUsers">{{ $t('z26multiple') }}</b>
                <b v-else>{{ $t('z26') }}</b>
              </div>
              <v-progress-linear indeterminate color="primary"></v-progress-linear> 
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isButtonOutlined: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    emailAddressOfUserToInvite: '',
    isShowingInviteUserDialog: false,
    isInvitationBeingSent: false,
    invitingUserErrorMsg: null,
    willInvitedUserBeAdmin: false,
    images: {
      sendEmail: require('@/assets/app/images/Brainstorming_session_Flatline.svg'),
    },
    wasUserSuccessfullyInvited: false,
    isInvitationForMultipleUsers: false,
    multipleInvitesStepNb: 0,
    multipleInvitesTextAreaModel: '',
    multipleEmailAddresses: [],
    additionalEmailAddress: '',
    isInviteMultipleUsersToJoinTeamPending: false
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    async inviteUser() {
      this.wasUserSuccessfullyInvited = false
      this.isInvitationBeingSent = true
      const response = await this.$functions.httpsCallable('inviteUserToJoinTeam')({
        emailAddressOfUserToInvite: this.emailAddressOfUserToInvite,
        willInvitedUserBeAdmin: this.willInvitedUserBeAdmin
      })
      if (response.data && response.data.error) {
        if (response.data.errorCode === 'invited-user-already-belongs-to-a-company') this.invitingUserErrorMsg = this.$t('z27')
        if (response.data.errorCode === 'invited-user-already-has-a-pending-request') this.invitingUserErrorMsg = this.$t('z28')
        if (response.data.errorCode === 'invited-user-already-has-a-pending-invitation') this.invitingUserErrorMsg = this.$t('z29')
        this.isInvitationBeingSent = false
      } else {
        this.isInvitationBeingSent = false
        this.wasUserSuccessfullyInvited = true
      }
    },
    isEmailAddressOfUserToInviteOk(email) {
      email = email.trim().toLowerCase()
      if (!email || !/.+@.+\..+/.test(email)) return false
      return this.user.company.emailDomains.includes(email.split('@')[1])
    },
    goToMultipleInvitesStepNb1() {
      this.multipleEmailAddresses = [... new Set(
        (this.multipleInvitesTextAreaModel.match(/([a-zA-Z0-9.+_-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi) || []) // eslint-disable-line
          .filter(this.isEmailAddressOfUserToInviteOk)
      )].sort((a, b) => a.localeCompare(b))
      this.multipleInvitesStepNb = 1
    },
    addAdditionalEmailAddress() {
      if (this.isEmailAddressOfUserToInviteOk(this.additionalEmailAddress)) {
        this.multipleEmailAddresses.push(this.additionalEmailAddress.trim())
        this.multipleEmailAddresses = [... new Set(this.multipleEmailAddresses)].filter(this.isEmailAddressOfUserToInviteOk).sort((a, b) => a.localeCompare(b))
        this.additionalEmailAddress = ''
      }
    },
    removeEmailFromMultipleEmailAddresses(email) {
      this.multipleEmailAddresses = this.multipleEmailAddresses.filter(x => x !== email)
    },
    async inviteMultipleUsersToJoinTeam() {
      this.isInviteMultipleUsersToJoinTeamPending = true
      try {
        await this.$functions.httpsCallable('inviteMultipleUsersToJoinTeam')({
          emailAddresses: this.multipleEmailAddresses
        })
        this.multipleEmailAddresses = []
        this.additionalEmailAddress = ''
        this.multipleInvitesTextAreaModel = ''
        this.multipleInvitesStepNb = 0
        console.log('Success'); // eslint-disable-line
      } finally {
        this.isInviteMultipleUsersToJoinTeamPending = false
        this.isShowingInviteUserDialog = false
      }
    },
  },
  watch: {
    isShowingInviteUserDialog: {
      handler(val, oldVal) {
        if (oldVal && !val) {
          this.emailAddressOfUserToInvite = ''
          this.invitingUserErrorMsg = null
          this.wasUserSuccessfullyInvited = false
          if (this.multipleInvitesStepNb === 0) {
            this.isInvitationForMultipleUsers = false
          }
        }
      }
    }
  }
}
</script>


<style scoped>
  .switch-center {
    display: flex;
    justify-content: center;
  }
</style>


<i18n>
{
  "fr": {
    "z19": "Inviter un collègue à rejoindre votre équipe",
    "z20": "Inviter un nouvel utilisateur à rejoindre votre équipe",
    "z21": "Votre collègue sera notifié par mail.",
    "z22": "Il pourra alors directement rejoindre votre équipe.",
    "z20multiple": "Inviter plusieurs nouveaux utilisateurs à rejoindre votre équipe",
    "z21multiple": "Vos collègues seront notifiés par mail.",
    "z22multiple": "Ils pourront alors directement rejoindre votre équipe.",
    "z23": "L'adresse email doit se terminer par",
    "z23multiple": "Les adresses email doivent se terminer par",
    "orWord": " ou ",
    "z24": "Adresse email de votre collègue",
    "z25": "Inviter",
    "z26": "Envoi de l'invitation en cours",
    "z26multiple": "Envoi des invitations en cours",
    "z27": "Invitation non envoyée. L'utilisateur invité est déjà dans une équipe.",
    "z28": "Invitation non envoyée. L'utilisateur invité a déjà une demande en attente de réponse de votre part.",
    "z29": "Invitation non envoyée. Une invitation à rejoindre votre équipe a déjà été envoyée à cet utilisateur.",

    "za": "Faire de votre collègue un Administrateur.",
    "userWasSuccessfullyInvitedMsg": "L'utilisateur a été invité avec succès.",

    "multiple1": "Inviter plusieurs utilisateurs ?",
    "multiple2": "Inviter un seul utilisateur ?",
    "multiple3": "Collez ici votre liste d'adresses email",
    "multiple4": "Suivant",
    "multiple5": "Retour à l'étape 1",
    "multiple6": "Ajouter une adresse email",
    "multiple7": "Ajouter",
    "multiple8": "adresses email.",
    "multiple9": "adresse email.",
    "multiple10": "Inviter"
},
  "en": {
    "z19": "Invite a co-worker to join your team",
    "z20": "Invite a new user to join your team",
    "z21": "Your co-worker will be notified by email.",
    "z22": "He will directly be able to join your team.",
    "z20multiple": "Invite multiple new users to join your team",
    "z21multiple": "Your co-workers will be notified by email.",
    "z22multiple": "They will directly be able to join your team.",
    "z23": "The email address must end with",
    "z23multiple": "The email addresses must end with",
    "orWord": " or ",
    "z24": "Email address of your co-worker",
    "z25": "Invite",
    "z26": "Invitation is being sent",
    "z26multiple": "Invitations are being sent",
    "z27": "Invitation not sent. The invited user is already in a team.",
    "z28": "Invitation not sent. The invited user already has a pending request waiting for your answer.",
    "z29": "Invitation not sent. An invitation to join your team has already been sent to this user.",

    "za": "Make co-worker a team Admin.",
    "userWasSuccessfullyInvitedMsg": "User was successfully invited",

    "multiple1": "Invite multiple users ?",
    "multiple2": "Invite only one user ?",
    "multiple3": "Paste here your list of email addresses",
    "multiple4": "Next",
    "multiple5": "Back to step 1",
    "multiple6": "Add an email address",
    "multiple7": "Add",
    "multiple8": "email addresses.",
    "multiple9": "email address.",
    "multiple10": "Invite"
  }
}
</i18n>
